import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../services/LogoutFunction";

export const addCourseApi = createAsyncThunk(
  "createCourse",
  async (courseData) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/courses/create`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
        body: courseData,
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("response", result);
        return result;
      })
      .catch((error) => {
        console.log("error", error);
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const addCourseSlicer = createSlice({
  name: "addCourse",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(addCourseApi.pending, (state) => {
      state.loading = true;
      state.data = null;
      state.error = null;
    });
    builder.addCase(addCourseApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      } else if (action.payload.message === "course added successfully") {
        state.data = action.payload.data;
        state.error = null;
      } else {
        state.data = null;
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(addCourseApi.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default addCourseSlicer.reducer;
